import React from 'react';
import './Terms&Conditions.css';
import SEO from '../../components/SEO';

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <SEO 
        title="Terms and Conditions | Techie Interiors" 
        description="Read the terms and conditions for using the Techie Interiors E-commerce Platform and our services in Kenya." 
        url="https://techieinteriors.co.ke/terms-and-conditions" 
      />
      <div className="terms-header">
        <h1>Terms and Conditions</h1>
        <p className="terms-subtitle">Techie Interiors E-commerce Platform (Kenya)</p>
      </div>

      <div className="terms-section">
        <h2>1. Introduction</h2>
        <p>
          Welcome to Techie Interiors. These Terms and Conditions ("Terms") govern your access to and use of our website, mobile platform, and services within Kenya.
        </p>
        <p>
          By using our Platform, you agree to be legally bound by these Terms in accordance with the laws of the Republic of Kenya.
        </p>
      </div>

      <div className="terms-section">
        <h2>2. Definitions</h2>
        <ul>
          <li><strong>"Company," "We," "Us," "Our"</strong> refers to Techie Interiors.</li>
          <li><strong>"User," "Customer," "You"</strong> refers to any person using the Platform.</li>
          <li><strong>"Products"</strong> refers to items sold via the Platform.</li>
          <li><strong>"Services"</strong> refers to interior design, installation, consultation, and related services.</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>3. Eligibility</h2>
        <p>You must:</p>
        <div className="eligibility-box">
          <ul>
            <li>Be at least 18 years old</li>
            <li>Have legal capacity to enter into contracts under Kenyan law</li>
          </ul>
        </div>
      </div>

      <div className="terms-section">
        <h2>4. Account Registration</h2>
        <p>You agree to:</p>
        <div className="account-responsibilities">
          <ul>
            <li>Provide accurate and complete information</li>
            <li>Keep login credentials secure</li>
            <li>Be responsible for all activity under your account</li>
          </ul>
        </div>
        <p>We may suspend or terminate accounts for violations.</p>
      </div>

      <div className="terms-section">
        <h2>5. Products and Services</h2>
        
        <div className="products-services-grid">
          <div className="product-box">
            <h4>5.1 Products</h4>
            <p>We offer interior products including:</p>
            <ul>
              <li>Gypsum materials</li>
              <li>Wall panels</li>
              <li>Furniture and fittings</li>
              <li>Custom interior décor items</li>
            </ul>
            <p>All products are subject to availability.</p>
          </div>

          <div className="service-box">
            <h4>5.2 Services</h4>
            <p>We provide:</p>
            <ul>
              <li>Interior design services</li>
              <li>Installation services</li>
              <li>Site consultation</li>
            </ul>
            <p>Service terms (timelines, scope, pricing) may be governed by separate agreements or quotations.</p>
          </div>
        </div>
      </div>

      <div className="terms-section">
        <h2>6. Pricing and Payments</h2>
        <ul>
          <li>Prices are listed in Kenyan Shillings (KES)</li>
          <li>Prices may change without notice</li>
          <li>Prices may include or exclude VAT as indicated</li>
        </ul>
        
        <h3>Accepted Payment Methods</h3>
        <div className="payment-methods">
          <ul>
            <li>M-Pesa</li>
            <li>Debit/Credit Cards</li>
            <li>Bank Transfers</li>
          </ul>
        </div>
        <p>Orders will only be processed after full payment is received unless otherwise agreed.</p>
      </div>

      <div className="terms-section">
        <h2>7. Orders and Acceptance</h2>
        <ul>
          <li>Orders are subject to acceptance and availability</li>
          <li>We reserve the right to cancel orders due to:
            <ul>
              <li>Pricing errors</li>
              <li>Fraud suspicion</li>
              <li>Stock unavailability</li>
            </ul>
          </li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>8. Delivery Policy</h2>
        <ul>
          <li>Delivery timelines are estimates only</li>
          <li>We deliver within Kenya via third-party logistics providers</li>
        </ul>
        
        <h3>Risk Transfer</h3>
        <p>Risk passes to the customer upon delivery.</p>
      </div>

      <div className="terms-section">
        <h2>9. Returns, Refunds, and Cancellations</h2>
        
        <h3>9.1 14-Day Return Policy</h3>
        <p>You may return eligible products within 14 days from the date of delivery.</p>
        
        <div className="return-policy-box">
          <h4>Conditions for Returns</h4>
          <ul>
            <li>Product must be unused</li>
            <li>Product must be in original condition and packaging</li>
            <li>Proof of purchase is required</li>
          </ul>
        </div>

        <h3>9.2 Non-Returnable Items</h3>
        <div className="non-returnable-box">
          <ul>
            <li>Custom-made or personalized items</li>
            <li>Installed products</li>
            <li>Used or damaged items not due to our fault</li>
          </ul>
        </div>

        <h3>9.3 Refunds</h3>
        <div className="refund-info">
          <ul>
            <li>Refunds are processed after inspection</li>
            <li>Refunds will be issued via original payment method (e.g., M-Pesa reversal or bank transfer)</li>
            <li>Processing time: 7–14 business days</li>
          </ul>
        </div>

        <h3>9.4 Order Cancellation</h3>
        <ul>
          <li>Allowed before dispatch</li>
          <li>Not allowed for custom or service-based orders once work has begun</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>10. Consumer Protection Compliance</h2>
        <p>These Terms comply with the Kenyan Consumer Protection Act, 2012.</p>
        <div className="compliance-box">
          <p><strong>Customers are entitled to:</strong></p>
          <ul>
            <li>Goods of reasonable quality</li>
            <li>Accurate product descriptions</li>
            <li>Fair pricing and disclosure</li>
          </ul>
        </div>
      </div>

      <div className="terms-section">
        <h2>11. Intellectual Property</h2>
        <p>All content on the Platform is owned by Techie Interiors.</p>
        <p>You may not:</p>
        <ul>
          <li>Copy or reproduce content</li>
          <li>Use branding without permission</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>12. User Conduct</h2>
        <p>You agree not to:</p>
        <ul>
          <li>Use the Platform unlawfully</li>
          <li>Interfere with operations</li>
          <li>Provide false or misleading information</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>13. Third-Party Services</h2>
        <p>We may use third-party providers (e.g., delivery, payment gateways).</p>
        <p>We are not responsible for:</p>
        <ul>
          <li>Third-party service interruptions</li>
          <li>External platform errors</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>14. Warranty Disclaimer</h2>
        <div className="warranty-disclaimer">
          <ul>
            <li>Products are provided "as is" unless otherwise stated</li>
            <li>No guarantees on uninterrupted access to the Platform</li>
          </ul>
        </div>
      </div>

      <div className="terms-section">
        <h2>15. Limitation of Liability</h2>
        <p>To the extent permitted by Kenyan law:</p>
        <div className="liability-box">
          <p><strong>Techie Interiors shall not be liable for:</strong></p>
          <ul>
            <li>Indirect or consequential losses</li>
            <li>Loss of profits or business opportunities</li>
          </ul>
          <p>Our total liability shall not exceed the amount paid for the product or service.</p>
        </div>
      </div>

      <div className="terms-section">
        <h2>16. Installation & Service Liability</h2>
        <div className="installation-box">
          <ul>
            <li>Customers must ensure site readiness before installation</li>
            <li>We are not liable for:
              <ul>
                <li>Structural issues</li>
                <li>Pre-existing damages</li>
              </ul>
            </li>
          </ul>
          <p>Any defects must be reported within 48 hours of service completion.</p>
        </div>
      </div>

      <div className="terms-section">
        <h2>17. Indemnification</h2>
        <p>You agree to indemnify Techie Interiors against claims arising from:</p>
        <ul>
          <li>Misuse of the Platform</li>
          <li>Breach of these Terms</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>18. Privacy</h2>
        <p>
          Your data is handled in accordance with our Privacy Policy and the Data Protection Act, 2019 (Kenya).
        </p>
      </div>

      <div className="terms-section">
        <h2>19. Force Majeure</h2>
        <p>We are not liable for delays caused by:</p>
        <ul>
          <li>Natural disasters</li>
          <li>Government restrictions</li>
          <li>Supply chain disruptions</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>20. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the Republic of Kenya.
        </p>
      </div>

      <div className="terms-section">
        <h2>21. Dispute Resolution</h2>
        <p>Disputes shall be resolved through:</p>
        <div className="dispute-resolution">
          <ol>
            <li>Negotiation</li>
            <li>Mediation</li>
            <li>Kenyan courts (as a last resort)</li>
          </ol>
        </div>
      </div>

      <div className="terms-section">
        <h2>22. Changes to Terms</h2>
        <ul>
          <li>We reserve the right to update these Terms at any time.</li>
          <li>Continued use of the Platform means acceptance of updated Terms.</li>
        </ul>
      </div>

      <div className="terms-section">
        <h2>23. Contact Information</h2>
        <div className="contact-info-box">
          <p><strong>Techie Interiors</strong></p>
          <p>Email: techieinteriors@gmail.com</p>
          <p>Phone: +254748600208</p>
          <p>Location: Corner A Githunguri, Ruiru, Kenya</p>
        </div>
      </div>

      <div className="terms-section">
        <h2>24. Entire Agreement</h2>
        <div className="important-notice">
          <p>
            These Terms constitute the full agreement between you and Techie Interiors.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;